import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MarkUnseenIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M10 8.27154C11.2743 7.54321 12.754 7 14.3333 7C19.1248 7 22 12 22 12C22 12 19.1248 17 14.3333 17C12.754 17 11.2743 16.4568 10 15.7285M7 10L5 11.9459M5 11.9459L3 10M5 11.9459L7 14M5 11.9459L3 14M12 12C12 13.1046 12.6716 14 13.5 14C14.3284 14 15 13.1046 15 12C15 10.8954 14.3284 10 13.5 10C12.6716 10 12 10.8954 12 12Z'
    stroke='#0058AD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default MarkUnseenIcon;
